import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalService } from './confirmation-modal.service';

@Component({
  selector: 'app-confimation-modal',
  templateUrl: './confimation-modal.component.html',
  styleUrls: ['./confimation-modal.component.scss'],
})
export class ConfimationModalComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() btnPreviewExist: string;
  @Input() isPreviewExist:boolean;


  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public downloadPreview() {
    this.activeModal.close('Preview Click');
    console.log(this.activeModal)
  }

  public dismiss(type) {
    this.activeModal.dismiss(type);
  }

}